<template>
  <div>
    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="fullName">Nom complet <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            id="fullName"
            v-model="cost.fullName"
            placeholder="Entrez le nom complet du coût"
          />
        </div>
      </div>

      <div class="col-md-3">
        <div class="form-group">
          <label for="tva">TVA %</label>
          <input
            type="number"
            step="0.01"
            class="form-control"
            id="tva"
            v-model="cost.tva"
            placeholder="0.00"
          />
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="remark">Remarque</label>
          <textarea
            class="form-control"
            id="remark"
            v-model="cost.remark"
            rows="3"
            placeholder="Ajoutez une remarque si nécessaire"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto">
        <button
          @click="$router.push({ name: 'costs-index' })"
          class="btn btn-secondary"
        >
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
      <div class="col-auto">
        <button @click="save(cost)" class="btn btn-success">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("cost", {
      cost: "getCost",
    }),
  },
  mounted() {
    this.$store.dispatch("cost/show", this.$route.params.reference);
  },
  methods: {
    async save(data) {
      if (!data.fullName || data.fullName.trim() === "") {
        await this.$store.dispatch("notification/store", {
          status: "error",
          message: "Le nom complet est obligatoire.",
        });
        return;
      }

      await this.$store.dispatch("cost/update", { ...data, is_importation: true });
      this.$router.push({ name: "costs-index" });
    },
  },
};
</script>

